import axios from "axios";
import { CategoryType } from "enums";
import { CategoryCorpLargeModel, CategoryModel } from "models";
import { CommonFileModel } from "models/CommonFileModel";
import { IAPIResult } from "models/interfaces";
import { Utils } from "utils";

export async function list(): Promise<IAPIResult<CategoryModel[]>> {
  // await Utils.sleep(300);
  const response = await axios.get<IAPIResult<CategoryCorpLargeModel[]>>(
    "/api.d/v1/ec/category-corp/list"
  );
  // return response.data;

  const tmp = response.data.data;
  const data: CategoryModel[] = [];
  for (let c of tmp) {
    let mList: CategoryModel[] = [];
    if (c.corp_medium_list) {
      mList = c.corp_medium_list.map((m) => {
        return {
          type: CategoryType.MIDDLE,
          id: m.corp_medium_category_id,
          name: m.corp_medium_category_name,
          sort_no: m.sort_no,
          list: [],
        };
      });
    }
    data.push({
      type: CategoryType.LARGE,
      id: c.corp_large_category_id,
      name: c.corp_large_category_name,
      sort_no: c.sort_no,
      image: c.corp_large_category_image,
      list: mList,
    });
  }

  return {
    data,
    error: response.data.error,
  };
}

export async function create(
  data:
    | { name: string; image: CommonFileModel }
    | { name: string; parent_id: string }
) {
  if ("image" in data) {
    return _create({
      corp_category_type: CategoryType.LARGE,
      corp_category_name: data.name,
      corp_large_category_image: data.image,
    });
  } else {
    return _create({
      corp_category_type: CategoryType.MIDDLE,
      corp_category_name: data.name,
      corp_large_category_id: data.parent_id,
    });
  }
}

export async function _create(
  data:
    | {
        corp_category_type: CategoryType.LARGE;
        corp_category_name: string;
        corp_large_category_image: CommonFileModel;
      }
    | {
        corp_category_type: CategoryType.MIDDLE;
        corp_category_name: string;
        corp_large_category_id: string;
      }
) {
  const response = await axios.post<IAPIResult>(
    "/api.d/v1/ec/category-corp/create",
    data
  );
  return response.data;
}

export async function update(
  data: CategoryModel,
  breadcrumb: CategoryModel[],
  name: string,
  image?: CommonFileModel
) {
  Utils.addDeleteFlag(image);
  if (data.type === CategoryType.LARGE) {
    return _update({
      corp_category_type: data.type,
      corp_category_name: name,
      corp_large_category_id: data.id,
      corp_large_category_image: image!,
    });
  } else if (data.type === CategoryType.MIDDLE) {
    return _update({
      corp_category_type: data.type,
      corp_category_name: name,
      corp_large_category_id: breadcrumb[0].id,
      corp_medium_category_id: data.id,
    });
  } else {
    throw new Error();
  }
}

export async function _update(
  data:
    | {
        corp_category_type: CategoryType.LARGE;
        corp_category_name: string;
        corp_large_category_id: string;
        corp_large_category_image: CommonFileModel;
      }
    | {
        corp_category_type: CategoryType.MIDDLE;
        corp_category_name: string;
        corp_large_category_id: string;
        corp_medium_category_id: string;
      }
) {
  const response = await axios.put<IAPIResult>(
    "/api.d/v1/ec/category-corp/update",
    data
  );
  return response.data;
}

export async function del(target: CategoryModel, breadcrumb: CategoryModel[]) {
  if (target.type === CategoryType.LARGE) {
    return _del({
      corp_category_type: target.type,
      corp_large_category_id: target.id,
    });
  } else if (target.type === CategoryType.MIDDLE) {
    return _del({
      corp_category_type: target.type,
      corp_large_category_id: breadcrumb[0].id,
      corp_medium_category_id: target.id,
    });
  } else {
    throw new Error();
  }
}

export async function _del(
  data:
    | {
        corp_category_type: CategoryType.LARGE;
        corp_large_category_id: string;
      }
    | {
        corp_category_type: CategoryType.MIDDLE;
        corp_large_category_id: string;
        corp_medium_category_id: string;
      }
) {
  // await Utils.sleep(300);

  const response = await axios.delete<IAPIResult>(
    "/api.d/v1/ec/category-corp/delete",
    { data }
  );
  return response.data;
}

export async function sort(corps: CategoryModel[]) {
  const tmp = corps.map((v, i) => {
    return {
      corp_large_category_id: v.id,
      corp_large_category_image: v.image,
      corp_large_category_name: v.name,
      corp_medium_category_list: v.list.map((vv, ii) => {
        return {
          corp_medium_category_id: vv.id,
          corp_medium_category_name: vv.name,
          corp_small_category_list: vv.list.map((vvv, iii) => {
            return {
              corp_small_category_id: vvv.id,
              corp_small_category_name: vvv.name,
              sort_no: iii + 1,
            };
          }),
          sort_no: ii + 1,
        };
      }),
      sort_no: i + 1,
    };
  });

  const response = await axios.put<IAPIResult>(
    "/api.d/v1/ec/category-corp/sort-update",
    tmp
  );
  return response.data;
}
